import React from 'react';
import { useMobile } from '../../../Components/Mobile';
import { usePreference } from '../../../Data/Preference';
import Alert from '../../../Components/Alert';
import Button from '../../../Components/Button/Button';
import { useHelp } from '../../../Components/Help';

const MobileNotifications = () => {
    const {isMobile, notificationsEnabled, requestNotifications} = useMobile();
    const [isDismissed, setIsDismissed] = usePreference('notifications-dismissed', false, true);
    const [requested, setRequested] = usePreference('notifications-requested', false);
    const {showHelp} = useHelp();

    if (!isMobile || notificationsEnabled !== false || isDismissed) {
        return null;
    }

    const doRequestNotifications = () => {
        requestNotifications();
        setTimeout(() => setRequested(true), 1000);
    }

    return <Alert theme="info"
        icon="Bell"
        title="Enable notifications"
        message="For example when quotes are received, customers send you messages, or leads are available in your area."
        buttons={<>
            <Button theme="light" label="Help" onClick={() => showHelp('enablingMobileNotifications')} zeroMargin hide={!requested} />
            <span className="grow" />
            <Button theme="secondary" label="Not now" onClick={() => setIsDismissed(true)} zeroMargin />
            <Button theme="primary" label="Yes please" onClick={() => doRequestNotifications()} zeroMargin />
        </>}
    />
}

export default MobileNotifications;
